import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import PageTitle from './components/layout/PageTitle';
import StructuredData from './components/layout/StructuredData';
import Landing from './components/pages/Landing';
import Market from './components/pages/Market';
import Dashboard from './components/pages/Dashboard';
import TickerDetails from './components/pages/TickerDetails';
import AboutProject from './components/pages/AboutProject';
import WhatsNext from './components/pages/WhatsNext';
import SearchPage from './components/pages/SearchPage';
import Blog from './components/pages/Blog';
import BlogList from './components/pages/BlogList';
import Login from './components/pages/Login';
import Pricing from './components/pages/Pricing';
import Billing from './components/pages/Billing';
import BillingSuccess from './components/pages/BillingSuccess';
import Profile from './components/pages/Profile';
import Terms from './components/pages/Terms';
import Privacy from './components/pages/Privacy';
import RiskDisclosure from './components/pages/RiskDisclosure';
import CookieConsentBanner from './components/ui/CookieConsentBanner';

// Компонент-обёртка для редиректа на About при первом заходе
const FirstVisitRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem('sentihype_first_visit')) {
      localStorage.setItem('sentihype_first_visit', '1');
      const allowedPaths = ['/about', '/market', '/terms', '/privacy', '/risk-disclosure'];
      if (!allowedPaths.includes(location.pathname)) {
        navigate('/about', { replace: true });
      }
    }
  }, [location, navigate]);
  return <>{children}</>;
};

function App() {
  return (
    <AuthProvider>
    <Router>
      <div className="min-h-screen h-screen overflow-hidden text-white font-sans flex flex-col noise sh-bg z-[1] overflow-x-hidden max-w-[100vw]">
        {/* Global Background Image */}
        <div className="sh-bg-overlay sh-bg-overlay--app bg-black/40 bg-blend-darken saturate-[0.9] contrast-[1.0]" />
        <PageTitle />
        <StructuredData />
        <FirstVisitRedirect>
          <div className="app-below-header flex-1 flex flex-col min-h-0 overflow-x-hidden">
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/auth/verify" element={<Login />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/market" element={<Market />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/ticker/:ticker" element={<TickerDetails />} />
                <Route path="/whatsnext" element={<WhatsNext />} />
                <Route path="/about" element={<AboutProject />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/billing" element={<Billing />} />
                <Route path="/billing/success" element={<BillingSuccess />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/risk-disclosure" element={<RiskDisclosure />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/opendoor" element={<Blog />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </div>
        </FirstVisitRedirect>
        <CookieConsentBanner />
      </div>
    </Router>
    </AuthProvider>
  );
}

export default App;
